'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Blockquote = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Blockquote = require('./Blockquote');

var _Blockquote2 = _interopRequireDefault(_Blockquote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Blockquote = _Blockquote2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-blockquote')(_Blockquote2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-blockquote/lib/cjs/index.js
 ** module id = 268
 ** module chunks = 1
 **/